export default __webpack_public_path__ + "b9743f88ec0c80efb01caea05dc36e65.png";